(() => {
  "use strict";
  var e = function (e, t, n, r) {
      return new (n || (n = Promise))(function (a, i) {
        function o(e) {
          try {
            l(r.next(e));
          } catch (e) {
            i(e);
          }
        }
        function s(e) {
          try {
            l(r.throw(e));
          } catch (e) {
            i(e);
          }
        }
        function l(e) {
          var t;
          e.done
            ? a(e.value)
            : ((t = e.value),
              t instanceof n
                ? t
                : new n(function (e) {
                    e(t);
                  })).then(o, s);
        }
        l((r = r.apply(e, t || [])).next());
      });
    },
    t = function (e, t) {
      var n,
        r,
        a,
        i,
        o = {
          label: 0,
          sent: function () {
            if (1 & a[0]) throw a[1];
            return a[1];
          },
          trys: [],
          ops: [],
        };
      return (
        (i = { next: s(0), throw: s(1), return: s(2) }),
        "function" == typeof Symbol &&
          (i[Symbol.iterator] = function () {
            return this;
          }),
        i
      );
      function s(i) {
        return function (s) {
          return (function (i) {
            if (n) throw new TypeError("Generator is already executing.");
            for (; o; )
              try {
                if (
                  ((n = 1),
                  r &&
                    (a =
                      2 & i[0]
                        ? r.return
                        : i[0]
                          ? r.throw || ((a = r.return) && a.call(r), 0)
                          : r.next) &&
                    !(a = a.call(r, i[1])).done)
                )
                  return a;
                switch (((r = 0), a && (i = [2 & i[0], a.value]), i[0])) {
                  case 0:
                  case 1:
                    a = i;
                    break;
                  case 4:
                    return (o.label++, { value: i[1], done: !1 });
                  case 5:
                    (o.label++, (r = i[1]), (i = [0]));
                    continue;
                  case 7:
                    ((i = o.ops.pop()), o.trys.pop());
                    continue;
                  default:
                    if (
                      !((a = o.trys),
                      (a = a.length > 0 && a[a.length - 1]) ||
                        (6 !== i[0] && 2 !== i[0]))
                    ) {
                      o = 0;
                      continue;
                    }
                    if (3 === i[0] && (!a || (i[1] > a[0] && i[1] < a[3]))) {
                      o.label = i[1];
                      break;
                    }
                    if (6 === i[0] && o.label < a[1]) {
                      ((o.label = a[1]), (a = i));
                      break;
                    }
                    if (a && o.label < a[2]) {
                      ((o.label = a[2]), o.ops.push(i));
                      break;
                    }
                    (a[2] && o.ops.pop(), o.trys.pop());
                    continue;
                }
                i = t.call(e, o);
              } catch (e) {
                ((i = [6, e]), (r = 0));
              } finally {
                n = a = 0;
              }
            if (5 & i[0]) throw i[1];
            return { value: i[0] ? i[1] : void 0, done: !0 };
          })([i, s]);
        };
      }
    },
    n = / /g,
    r = (function () {
      function r(e) {
        ((this.baseURI = "https://api.binderpos.com/shopify/filterTags/"),
          (this.divToAppendTo = document.querySelector(e.divToAppendTo)),
          (this.collectionType = e.collectionType),
          (this.requestPath = e.requestPath),
          (this.collectionHandle = e.collectionHandle),
          (this.activeTags =
            e.activeTags.length > 0 ? JSON.parse(e.activeTags) : ""),
          (this.currentTags =
            e.collectionTags.length > 0 ? JSON.parse(e.collectionTags) : ""),
          (this.supportedTags = void 0),
          (this.filterTags = void 0));
      }
      return (
        (r.prototype.init = function () {
          var e = this;
          localStorage.getItem(this.collectionType)
            ? ((this.supportedTags = JSON.parse(
                localStorage.getItem(this.collectionType),
              )),
              0 == this.supportedTags.length &&
                (this.divToAppendTo.innerHTML =
                  '<p style="white-space: break-spaces; text-align: center;">Filters for ' +
                  this.collectionType +
                  " not currently supported.</p>"),
              this.processBinderTags(),
              this.loadBinderTags().then(function (t) {
                ((e.supportedTags = t), e.setLocalStorage());
              }))
            : ((this.divToAppendTo.innerHTML =
                '<p style="white-space: break-spaces; text-align: center;">Fetching Filters for the First Time</p>'),
              this.loadBinderTags().then(function (t) {
                (0 == t.length
                  ? (e.divToAppendTo.innerHTML =
                      '<p style="white-space: break-spaces; text-align: center;">Filters for ' +
                      e.collectionType +
                      " not currently supported.</p>")
                  : (e.divToAppendTo.innerHTML = ""),
                  (e.supportedTags = t),
                  e.setLocalStorage(),
                  e.processBinderTags());
              }));
        }),
        (r.prototype.handleize = function (e) {
          e = e.toLowerCase();
          for (
            var t = ['"', "'", "\\", "(", ")", "[", "]"], n = 0;
            n < t.length;
            ++n
          )
            e = e.replace(t[n], "");
          return (
            "-" ==
              (e = e.replace(/[^a-z^A-Z^0-9^é]+/g, "-")).charAt(e.length - 1) &&
              (e = e.replace(/-+\z/, "")),
            "-" == e.charAt(0) && (e = e.replace(/\A-+/, "")),
            (e = e.replace("ø", "o").replace("æ", "ae").replace("å", "a"))
          );
        }),
        (r.prototype.setLocalStorage = function () {
          localStorage.setItem(
            this.collectionType,
            JSON.stringify(this.supportedTags),
          );
        }),
        (r.prototype.processBinderTags = function () {
          var e = this;
          (this.supportedTags.forEach(function (t) {
            e.filterTags = e.generateDisplayTags(t.tags);
            var n = e.generateFilterListCategory(t);
            e.filterTags.forEach(function (r) {
              e.generateFilterListItem(r, n, t);
            });
          }),
            this.initInputHandlers());
        }),
        (r.prototype.initInputHandlers = function () {
          var e = this;
          document.querySelectorAll("[filterCheckbox]").forEach(function (t) {
            t.addEventListener("keyup", e.filter);
          });
        }),
        (r.prototype.filter = function (e) {
          for (
            var t = e.target.value.replace(n, "_").toUpperCase(),
              r = document.querySelectorAll("ul." + e.target.id + " li"),
              a = 0;
            a < r.length;
            a++
          )
            r[a].getAttribute("filter-name").toUpperCase().includes(t)
              ? r[a].classList.remove("hide")
              : r[a].classList.add("hide");
        }),
        (r.prototype.generateFilterListItem = function (e, t, r) {
          var a = document.createElement("li");
          a.setAttribute("filter-name", e.tag.replace(n, "_").toUpperCase());
          var i = document.createElement("span");
          i.className = "custom-checkbox";
          var o = document.createElement("a");
          e.active
            ? (o.setAttribute("data-tagname", e.handle),
              (o.className = "selected"),
              o.setAttribute(
                "title",
                "Remove " + e.tag + " from your selection",
              ),
              (o.href = "#"))
            : (0 == this.activeTags.length
                ? (o.href =
                    "/collections/" +
                    (this.collectionHandle ? this.collectionHandle : "all") +
                    "/" +
                    e.handle)
                : (o.href = this.requestPath + "+" + e.handle),
              o.setAttribute("title", "Filter by " + r.name + ": " + e.tag));
          var s = document.createElement("span");
          ((s.className = "filter-box"),
            t.appendChild(a),
            a.appendChild(i),
            i.appendChild(o),
            o.appendChild(s),
            (o.innerHTML += " " + e.tag));
        }),
        (r.prototype.generateFilterListCategory = function (e) {
          var t = document.createElement("strong");
          if (
            ((t.innerHTML = e.name),
            this.divToAppendTo.appendChild(t),
            this.filterTags.length > 6)
          ) {
            var r = document.createElement("input");
            (r.setAttribute("filterCheckbox", null),
              (r.className = "checkbox__search"),
              r.setAttribute("placeholder", "Search " + e.name + "s"),
              (r.id = e.name.replace(n, "_").toUpperCase()),
              this.divToAppendTo.appendChild(r));
          }
          var a = document.createElement("ul");
          return (
            (a.className = e.name.replace(n, "_").toUpperCase()),
            this.divToAppendTo.appendChild(a),
            a
          );
        }),
        (r.prototype.titleCaseWord = function (e) {
          return e ? e.charAt(0).toUpperCase() + e.slice(1) : e;
        }),
        (r.prototype.stringIncludes = function (e, t) {
          return e.includes(t);
        }),
        (r.prototype.generateDisplayTags = function (e) {
          var t = this;
          if (this.currentTags.length >= 1e3 || 0 === this.currentTags.length)
            this.filtered = e.map(function (e) {
              return { tag: e, handle: t.handleize(e), active: !1 };
            });
          else {
            var n = e.map(function (e) {
              return e.replace(/"/g, "'").toUpperCase();
            });
            this.filtered = this.currentTags.filter(function (e) {
              return t.stringIncludes(n, e.tag.toUpperCase());
            });
          }
          return this.filtered.map(function (e) {
            return t.stringIncludes(t.activeTags, e.tag)
              ? ((e.active = !0), e)
              : ((e.active = !1), e);
          });
        }),
        (r.prototype.createShortCode = function (e) {
          switch (e.toLowerCase()) {
            case "mtg single":
              return "mtg";
            case "pokemon single":
              return "pkm";
            case "yu gi oh single":
            case "yugioh single":
              return "ygo";
            case "dragon ball super single":
              return "dbs";
            case "flesh and blood single":
              return "fab";
            default:
              return null;
          }
        }),
        (r.prototype.fetchApi = function (e) {
          return fetch(e, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }).then(function (e) {
            if (!e.ok) throw new Error(e.statusText);
            return e.json();
          });
        }),
        (r.prototype.loadBinderTags = function () {
          return e(this, void 0, void 0, function () {
            var e;
            return t(this, function (t) {
              switch (t.label) {
                case 0:
                  return null ===
                    (e = this.createShortCode(this.collectionType))
                    ? [3, 2]
                    : [4, this.fetchApi(this.baseURI + e)];
                case 1:
                  return [2, t.sent()];
                case 2:
                  return [2, []];
              }
            });
          });
        }),
        r
      );
    })();
  window.CollectionFilters = r;
})();

(function () {
  "use strict";

  function CustomTagFilters(options) {
    this.root = document.querySelector(options.divToAppendTo);
    this.collectionHandle = options.collectionHandle;
    this.sortBy = options.sortBy || "";
    // Map of "param::handle" → GID, built from collection.filters in Liquid
    this.filterValueMap = options.filterValueMap || {};
    this.filterConfig = this.normalizeConfig(options.filterConfig);
    this.managedHandles = new Set();
    this.handleToGroup = {};
    this.selectedHandles = this.getSelectedHandlesFromPath();
    this.groupLogicMode = this.getGroupLogicFromPath();
    this.selectedAvailability = this.getAvailabilityFromPath();
    this.sectionId = this.getSectionId();
  }

  CustomTagFilters.prototype.safeParse = function (value, fallback) {
    if (!value) {
      return fallback;
    }

    if (typeof value === "string") {
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    }

    return value;
  };

  CustomTagFilters.prototype.handleize = function (value) {
    if (!value) {
      return "";
    }

    return String(value)
      .toLowerCase()
      .replace(/["'\\()\[\]]/g, "")
      .replace(/[^a-z0-9^é]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace("ø", "o")
      .replace("æ", "ae")
      .replace("å", "a");
  };

  CustomTagFilters.prototype.getSelectedHandlesFromPath = function () {
    var selected = new Set();
    var urlParams = new URLSearchParams(window.location.search);

    urlParams.forEach(function (value, key) {
      if (key.indexOf("filter.p.m.") === 0) {
        selected.add(key + "::" + value);
      }
    });

    return selected;
  };

  CustomTagFilters.prototype.getAvailabilityFromPath = function () {
    var selected = new Set();
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.getAll("filter.v.availability").forEach(function (v) {
      selected.add(v);
    });
    return selected;
  };

  CustomTagFilters.prototype.getGroupLogicFromPath = function () {
    var modes = {};
    var urlParams = new URLSearchParams(window.location.search);

    urlParams.forEach(function (value, key) {
      if (key.indexOf("filter_logic.") === 0) {
        var groupKey = key.slice("filter_logic.".length);
        modes[groupKey] = value === "and" ? "and" : "or";
      }
    });

    return modes;
  };

  CustomTagFilters.prototype.normalizeConfig = function (inputConfig) {
    console.log("[CustomTagFilters] filterValueMap:", this.filterValueMap);
    console.log("[CustomTagFilters] raw inputConfig:", inputConfig);

    var config = this.safeParse(inputConfig, null);

    if (typeof config === "string") {
      config = this.safeParse(config, null);
    }

    if (!config) {
      console.warn(
        "[CustomTagFilters] config parsed to null — check metafield is set on the collection",
      );
      return { groups: [] };
    }

    var rawGroups =
      config.groups || config.filter_groups || config.categories || [];
    if (!Array.isArray(rawGroups)) {
      return { groups: [] };
    }

    var normalizedGroups = rawGroups
      .map(function (group) {
        var rawOptions =
          group.options ||
          group.values ||
          group.filter_options ||
          group.filterOptions ||
          [];

        if (!Array.isArray(rawOptions)) {
          rawOptions = [];
        }

        var options = rawOptions
          .map(function (option) {
            var label =
              option.label ||
              option.name ||
              option.display_name ||
              option.title ||
              "";
            // param: the full Shopify filter param name, e.g. "filter.p.m.custom.swu_arena_type"
            var param =
              option.param ||
              option.filter_param ||
              option.metafield_param ||
              "";
            // handle: the metaobject handle, e.g. "sorcery-rarity-unique"
            var handle = option.handle || option.value || "";
            // Resolve the GID from the Liquid-provided map keyed by "param::handle"
            var lookupKey = param + "::" + handle;
            var gid = handle ? this.filterValueMap[lookupKey] || "" : "";
            console.log(
              "[CustomTagFilters] option lookup:",
              lookupKey,
              "->",
              gid || "(not found)",
            );
            // Unique key used internally to track selection state (param::gid)
            var key = param && gid ? param + "::" + gid : "";

            return {
              label: label,
              param: param,
              handle: handle,
              value: gid,
              key: key,
              sortOrder: Number(option.sort_order || option.order || 0),
            };
          }, this)
          .filter(function (option) {
            return option.label && option.param && option.value && option.key;
          })
          .sort(function (a, b) {
            return a.sortOrder - b.sortOrder || a.label.localeCompare(b.label);
          });

        return {
          name:
            group.name ||
            group.label ||
            group.display_name ||
            group.title ||
            "Filter",
          key: this.handleize(
            group.name ||
              group.label ||
              group.display_name ||
              group.title ||
              "filter",
          ),
          searchEnabled: Boolean(
            group.search || group.search_enabled || group.enable_search,
          ),
          showMoreAfter: Number(
            group.show_more_after || group.showMoreAfter || 8,
          ),
          options: options,
        };
      }, this)
      .filter(function (group) {
        return group.options.length > 0;
      });

    return { groups: normalizedGroups };
  };

  CustomTagFilters.prototype.init = function () {
    if (!this.root) {
      return;
    }

    if (!this.filterConfig.groups.length) {
      this.root.insertAdjacentHTML(
        "beforeend",
        '<p class="custom-filter-empty">No custom filters are configured for this collection.</p>',
      );
      return;
    }

    this.render();
    this.bindEvents();
    this.syncInputsWithSelection();
    this.syncClearAllState();
  };

  CustomTagFilters.prototype.getSectionId = function () {
    var sectionRoot = document.getElementById("main-collection-product-grid");
    if (!sectionRoot) {
      return null;
    }
    return sectionRoot.getAttribute("data-id");
  };

  CustomTagFilters.prototype.renderAvailabilityGroup = function () {
    var _this = this;
    var options = [
      { label: "In Stock", value: "1" },
      { label: "Out of Stock", value: "0" },
    ];

    var groupContainer = document.createElement("div");
    groupContainer.className = "custom-filter-group";
    groupContainer.setAttribute("data-filter-group", "availability");

    var groupHeader = document.createElement("div");
    groupHeader.className = "custom-filter-group__header";

    var heading = document.createElement("strong");
    heading.className = "custom-filter-group__title";
    heading.textContent = "Availability";
    groupHeader.appendChild(heading);
    groupContainer.appendChild(groupHeader);

    var list = document.createElement("ul");
    list.className = "custom-filter-options";
    list.setAttribute("data-filter-list", "availability");

    options.forEach(function (option) {
      var item = document.createElement("li");
      item.className = "custom-filter-options__item";

      var label = document.createElement("label");
      label.className = "custom-filter-option";

      var input = document.createElement("input");
      input.type = "checkbox";
      input.className = "custom-filter-option__checkbox";
      input.value = option.value;
      input.checked = _this.selectedAvailability.has(option.value);
      input.setAttribute("data-availability-checkbox", "true");

      var marker = document.createElement("span");
      marker.className = "custom-filter-option__marker";

      var text = document.createElement("span");
      text.className = "custom-filter-option__label";
      text.textContent = option.label;

      label.appendChild(input);
      label.appendChild(marker);
      label.appendChild(text);
      item.appendChild(label);
      list.appendChild(item);
    });

    groupContainer.appendChild(list);
    _this.root.appendChild(groupContainer);
  };

  CustomTagFilters.prototype.render = function () {
    var _this = this;

    _this.renderAvailabilityGroup();

    this.filterConfig.groups.forEach(function (group) {
      group.options.forEach(function (option) {
        _this.managedHandles.add(option.key);
        _this.handleToGroup[option.key] = group.key;
      });

      var groupContainer = document.createElement("div");
      groupContainer.className = "custom-filter-group";
      groupContainer.setAttribute("data-filter-group", group.key);

      var groupHeader = document.createElement("div");
      groupHeader.className = "custom-filter-group__header";

      var heading = document.createElement("strong");
      heading.className = "custom-filter-group__title";
      heading.textContent = group.name;
      groupHeader.appendChild(heading);

      var currentMode = _this.groupLogicMode[group.key] || "or";
      var logicToggle = document.createElement("label");
      logicToggle.className = "custom-filter-logic-toggle";
      logicToggle.title = "Switch between OR / AND logic for this filter group";

      var logicCheckbox = document.createElement("input");
      logicCheckbox.type = "checkbox";
      logicCheckbox.className = "custom-filter-logic-toggle__checkbox";
      logicCheckbox.checked = currentMode === "and";
      logicCheckbox.setAttribute("data-logic-toggle", group.key);

      var logicTrack = document.createElement("span");
      logicTrack.className = "custom-filter-logic-toggle__track";

      var logicLabelOr = document.createElement("span");
      logicLabelOr.className =
        "custom-filter-logic-toggle__label custom-filter-logic-toggle__label--or";
      logicLabelOr.textContent = "OR";

      var logicLabelAnd = document.createElement("span");
      logicLabelAnd.className =
        "custom-filter-logic-toggle__label custom-filter-logic-toggle__label--and";
      logicLabelAnd.textContent = "AND";

      logicToggle.appendChild(logicCheckbox);
      logicToggle.appendChild(logicLabelOr);
      logicToggle.appendChild(logicTrack);
      logicToggle.appendChild(logicLabelAnd);
      groupHeader.appendChild(logicToggle);

      groupContainer.appendChild(groupHeader);

      if (group.searchEnabled && group.options.length > group.showMoreAfter) {
        var searchInput = document.createElement("input");
        searchInput.type = "search";
        searchInput.className = "checkbox__search custom-filter-group__search";
        searchInput.placeholder = "Search " + group.name;
        searchInput.setAttribute("data-filter-search", group.key);
        groupContainer.appendChild(searchInput);
      }

      var list = document.createElement("ul");
      list.className = "custom-filter-options";
      list.setAttribute("data-filter-list", group.key);

      group.options.forEach(function (option, index) {
        var isChecked = _this.selectedHandles.has(option.key);
        var shouldHide = index >= group.showMoreAfter;

        var item = document.createElement("li");
        item.className = "custom-filter-options__item";
        item.setAttribute("data-filter-label", option.label.toLowerCase());

        var label = document.createElement("label");
        label.className = "custom-filter-option";

        var input = document.createElement("input");
        input.type = "checkbox";
        input.className = "custom-filter-option__checkbox";
        // value is the unique key "param::value" used for selection tracking
        input.value = option.key;
        input.checked = isChecked;
        input.setAttribute("data-filter-checkbox", "true");
        input.setAttribute("data-filter-group", group.key);
        input.setAttribute("data-filter-param", option.param);
        input.setAttribute("data-filter-value", option.value);

        var marker = document.createElement("span");
        marker.className = "custom-filter-option__marker";

        var text = document.createElement("span");
        text.className = "custom-filter-option__label";
        text.textContent = option.label;

        label.appendChild(input);
        label.appendChild(marker);
        label.appendChild(text);
        item.appendChild(label);
        list.appendChild(item);
      });

      groupContainer.appendChild(list);
      _this.root.appendChild(groupContainer);
    });
  };

  CustomTagFilters.prototype.bindEvents = function () {
    var _this = this;

    this.root
      .querySelectorAll("[data-filter-checkbox]")
      .forEach(function (checkbox) {
        checkbox.addEventListener("change", function (event) {
          var key = event.target.value;

          if (event.target.checked) {
            _this.selectedHandles.add(key);
          } else {
            _this.selectedHandles.delete(key);
          }

          _this.navigateWithCurrentSelection();
        });
      });

    this.root
      .querySelectorAll("[data-availability-checkbox]")
      .forEach(function (checkbox) {
        checkbox.addEventListener("change", function (event) {
          if (event.target.checked) {
            _this.selectedAvailability.add(event.target.value);
          } else {
            _this.selectedAvailability.delete(event.target.value);
          }
          _this.navigateWithCurrentSelection();
        });
      });

    this.root
      .querySelectorAll("[data-filter-search]")
      .forEach(function (searchInput) {
        searchInput.addEventListener("input", function (event) {
          var groupKey = event.target.getAttribute("data-filter-search");
          var searchValue = event.target.value.trim().toLowerCase();
          var list = _this.root.querySelector(
            '[data-filter-list="' + groupKey + '"]',
          );

          if (!list) {
            return;
          }

          list
            .querySelectorAll(".custom-filter-options__item")
            .forEach(function (item) {
              var label = item.getAttribute("data-filter-label") || "";
              if (!searchValue || label.indexOf(searchValue) !== -1) {
                item.classList.remove("is-hidden-by-search");
              } else {
                item.classList.add("is-hidden-by-search");
              }
            });
        });
      });

    this.root
      .querySelectorAll("[data-logic-toggle]")
      .forEach(function (logicCheckbox) {
        logicCheckbox.addEventListener("change", function (event) {
          var groupKey = event.target.getAttribute("data-logic-toggle");
          _this.groupLogicMode[groupKey] = event.target.checked ? "and" : "or";
          _this.navigateWithCurrentSelection();
        });
      });

    var clearAll = this.root.querySelector(".clear-all");
    if (clearAll) {
      clearAll.addEventListener("click", function (event) {
        event.preventDefault();

        _this.selectedHandles.forEach(function (handle) {
          if (_this.managedHandles.has(handle)) {
            _this.selectedHandles.delete(handle);
          }
        });

        _this.root
          .querySelectorAll("[data-filter-checkbox]")
          .forEach(function (checkbox) {
            checkbox.checked = false;
          });

        _this.selectedAvailability.clear();
        _this.root
          .querySelectorAll("[data-availability-checkbox]")
          .forEach(function (checkbox) {
            checkbox.checked = false;
          });

        _this.navigateWithCurrentSelection();
      });
    }
  };

  CustomTagFilters.prototype.syncInputsWithSelection = function () {
    var _this = this;
    this.root
      .querySelectorAll("[data-filter-checkbox]")
      .forEach(function (checkbox) {
        checkbox.checked = _this.selectedHandles.has(checkbox.value);
      });
  };

  CustomTagFilters.prototype.getSelectedByGroup = function () {
    // Groups by filter param name (e.g. "filter.p.m.custom.swu_arena_type") → [gid, gid, ...]
    var selectedByParam = {};

    this.root
      .querySelectorAll("[data-filter-checkbox]:checked")
      .forEach(function (checkbox) {
        var param = checkbox.getAttribute("data-filter-param");
        var value = checkbox.getAttribute("data-filter-value");
        if (!param || !value) {
          return;
        }

        if (!selectedByParam[param]) {
          selectedByParam[param] = [];
        }

        selectedByParam[param].push(value);
      });

    return selectedByParam;
  };

  CustomTagFilters.prototype.getCartesianSelections = function (
    selectedByGroup,
  ) {
    var groupKeys = Object.keys(selectedByGroup).filter(function (group) {
      return selectedByGroup[group] && selectedByGroup[group].length;
    });

    if (!groupKeys.length) {
      return [[]];
    }

    return groupKeys.reduce(
      function (accumulator, group) {
        var options = selectedByGroup[group];
        var next = [];

        accumulator.forEach(function (existing) {
          options.forEach(function (value) {
            next.push(existing.concat(value));
          });
        });

        return next;
      },
      [[]],
    );
  };

  // Build base search params, including sort and metafield filter params for selected options
  CustomTagFilters.prototype.getBaseSearchParams = function (selectedByParam) {
    var _this = this;
    var params = new URLSearchParams();
    // Read current sort from the DOM (handles AJAX sort changes) or fall back to initial value
    var sortSelect = document.querySelector("#SortBy, #SortBy-mobile");
    var currentSort = (sortSelect && sortSelect.value) || this.sortBy;
    if (currentSort) {
      params.set("sort_by", currentSort);
    }
    // Emit filter.p.m.<namespace>.<key>=<gid> for each selected metafield option
    if (selectedByParam) {
      Object.keys(selectedByParam).forEach(function (filterParam) {
        selectedByParam[filterParam].forEach(function (gidValue) {
          params.append(filterParam, gidValue);
        });
      });
    }
    // Emit filter.v.availability for selected availability values
    _this.selectedAvailability.forEach(function (v) {
      params.append("filter.v.availability", v);
    });
    Object.keys(_this.groupLogicMode).forEach(function (groupKey) {
      if (_this.groupLogicMode[groupKey] === "and") {
        params.set("filter_logic." + groupKey, "and");
      }
    });
    return params.toString();
  };

  // Returns the param name for a given group key, or null if not found
  CustomTagFilters.prototype.getParamForGroup = function (groupKey) {
    var groups = this.filterConfig.groups;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].key === groupKey && groups[i].options.length) {
        return groups[i].options[0].param;
      }
    }
    return null;
  };

  // Always use /collections/{handle} (no tag-paths)
  CustomTagFilters.prototype.buildCollectionPath = function () {
    return "/collections/" + this.collectionHandle;
  };

  CustomTagFilters.prototype.fetchSectionHTML = function (searchParams) {
    if (!this.sectionId) {
      return Promise.resolve(null);
    }
    var requestUrl =
      this.buildCollectionPath() + "?section_id=" + this.sectionId;
    if (searchParams) {
      requestUrl += "&" + searchParams;
    }
    return fetch(requestUrl).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to fetch filtered collection section");
      }
      return response.text();
    });
  };

  CustomTagFilters.prototype.toggleCollectionLoading = function (isLoading) {
    var gridRoot = document.getElementById("CollectionProductGrid");
    var collectionContainer = gridRoot && gridRoot.querySelector(".collection");
    if (!collectionContainer) {
      return;
    }

    collectionContainer.classList.toggle("loading", isLoading);
  };

  CustomTagFilters.prototype.updateCollectionCount = function (count) {
    document
      .querySelectorAll(".collection-product-count")
      .forEach(function (element) {
        element.textContent = count + " items";
      });
  };

  CustomTagFilters.prototype.renderMergedProducts = function (htmlFragments) {
    if (!htmlFragments.length) {
      return;
    }

    var parser = new DOMParser();
    var uniqueProducts = new Map();

    htmlFragments.forEach(function (html) {
      var parsed = parser.parseFromString(html, "text/html");
      var list = parsed.getElementById("main-collection-product-grid");
      if (!list) {
        return;
      }

      list.querySelectorAll("li").forEach(function (item) {
        var productLink = item.querySelector('a[href*="/products/"]');
        if (!productLink) {
          return;
        }

        var key = productLink.getAttribute("href").split("?")[0];
        if (!uniqueProducts.has(key)) {
          uniqueProducts.set(key, item.outerHTML);
        }
      });
    });

    var targetList = document.getElementById("main-collection-product-grid");
    if (!targetList) {
      return;
    }

    targetList.innerHTML = Array.from(uniqueProducts.values()).join("");

    var paginationBlock = document.querySelector(
      "#CollectionProductGrid .pagination-block",
    );
    if (paginationBlock) {
      paginationBlock.style.display = "none";
    }

    this.updateCollectionCount(uniqueProducts.size);

    if (typeof setGridLayout === "function") {
      setGridLayout();
    }
    if (typeof setupWishlistButtons === "function") {
      setupWishlistButtons();
    }
  };

  // Build per-value search params for AND logic (one request per value in the AND group)
  CustomTagFilters.prototype.getAndRequestParams = function (
    selectedByParam,
    andGroupParam,
    singleValue,
  ) {
    var _this = this;
    var params = new URLSearchParams();
    var sortSelect = document.querySelector("#SortBy, #SortBy-mobile");
    var currentSort = (sortSelect && sortSelect.value) || this.sortBy;
    if (currentSort) {
      params.set("sort_by", currentSort);
    }
    Object.keys(selectedByParam).forEach(function (filterParam) {
      if (filterParam === andGroupParam) {
        params.append(filterParam, singleValue);
      } else {
        selectedByParam[filterParam].forEach(function (gidValue) {
          params.append(filterParam, gidValue);
        });
      }
    });
    Object.keys(_this.groupLogicMode).forEach(function (groupKey) {
      if (_this.groupLogicMode[groupKey] === "and") {
        params.set("filter_logic." + groupKey, "and");
      }
    });
    return params.toString();
  };

  // Extract product href keys from an HTML string
  CustomTagFilters.prototype.extractProductKeys = function (html) {
    var parser = new DOMParser();
    var parsed = parser.parseFromString(html, "text/html");
    var keys = new Set();
    var list = parsed.getElementById("main-collection-product-grid");
    if (list) {
      list.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        keys.add(a.getAttribute("href").split("?")[0]);
      });
    }
    return keys;
  };

  // Intersect two Sets
  CustomTagFilters.prototype.intersectSets = function (a, b) {
    var result = new Set();
    a.forEach(function (key) {
      if (b.has(key)) result.add(key);
    });
    return result;
  };

  // Use Shopify filter query params for backend OR/AND filtering
  CustomTagFilters.prototype.renderViaAjax = function (
    selectedCombinations,
    selectedByGroup,
  ) {
    var _this = this;
    var searchParams = this.getBaseSearchParams(selectedByGroup);
    var nextUrl =
      this.buildCollectionPath() + (searchParams ? "?" + searchParams : "");

    this.toggleCollectionLoading(true);
    history.pushState({ searchParams: searchParams }, "", nextUrl);

    // Determine if any group uses AND logic with 2+ selected values
    var andGroups = [];
    Object.keys(_this.groupLogicMode).forEach(function (groupKey) {
      if (_this.groupLogicMode[groupKey] !== "and") return;
      var param = _this.getParamForGroup(groupKey);
      if (
        param &&
        selectedByGroup[param] &&
        selectedByGroup[param].length > 1
      ) {
        andGroups.push({ groupKey: groupKey, param: param });
      }
    });

    // If no AND groups with multiple selections, use the standard single-request path
    if (!andGroups.length) {
      var ajaxForm = document.querySelector("collection-filters-form");
      if (ajaxForm && typeof ajaxForm.renderPage === "function") {
        ajaxForm.renderPage(searchParams, null, false);
        return;
      }
      this.fetchSectionHTML(searchParams)
        .then(function (html) {
          if (html) _this.renderMergedProducts([html]);
        })
        .catch(function () {
          window.location.assign(nextUrl);
        })
        .finally(function () {
          _this.toggleCollectionLoading(false);
        });
      return;
    }

    // AND logic: make one request per selected value in the AND group, intersect product sets
    // For simplicity, handle the first AND group; further groups compound naturally via Shopify OR per group
    var andGroup = andGroups[0];
    var andValues = selectedByGroup[andGroup.param];

    var requests = andValues.map(function (singleValue) {
      var perValueParams = _this.getAndRequestParams(
        selectedByGroup,
        andGroup.param,
        singleValue,
      );
      return _this.fetchSectionHTML(perValueParams);
    });

    Promise.all(requests)
      .then(function (htmlFragments) {
        // Build intersection of product keys across all responses
        var productKeySets = htmlFragments.filter(Boolean).map(function (html) {
          return _this.extractProductKeys(html);
        });

        if (!productKeySets.length) return;

        var intersectedKeys = productKeySets.reduce(function (acc, set) {
          return _this.intersectSets(acc, set);
        });

        // Use first response as source of product HTML, filtered to intersected keys
        var parser = new DOMParser();
        var parsed = parser.parseFromString(htmlFragments[0], "text/html");
        var sourceList = parsed.getElementById("main-collection-product-grid");
        var targetList = document.getElementById(
          "main-collection-product-grid",
        );
        if (!sourceList || !targetList) return;

        var filteredItems = [];
        sourceList.querySelectorAll("li").forEach(function (item) {
          var a = item.querySelector('a[href*="/products/"]');
          if (a && intersectedKeys.has(a.getAttribute("href").split("?")[0])) {
            filteredItems.push(item.outerHTML);
          }
        });

        targetList.innerHTML = filteredItems.join("");

        var paginationBlock = document.querySelector(
          "#CollectionProductGrid .pagination-block",
        );
        if (paginationBlock) paginationBlock.style.display = "none";

        _this.updateCollectionCount(filteredItems.length);

        if (typeof setGridLayout === "function") setGridLayout();
        if (typeof setupWishlistButtons === "function") setupWishlistButtons();
      })
      .catch(function () {
        window.location.assign(nextUrl);
      })
      .finally(function () {
        _this.toggleCollectionLoading(false);
      });
  };

  CustomTagFilters.prototype.syncClearAllState = function () {
    var clearAll = this.root.querySelector(".clear-all");
    if (!clearAll) {
      return;
    }

    var hasChecked =
      this.root.querySelectorAll(
        "[data-filter-checkbox]:checked, [data-availability-checkbox]:checked",
      ).length > 0;
    clearAll.style.display = hasChecked ? "inline-block" : "none";
  };

  CustomTagFilters.prototype.navigateWithCurrentSelection = function () {
    var selectedByGroup = this.getSelectedByGroup();

    // Rebuild selectedHandles (handle-based) from the checked checkboxes
    var nextSelectedHandles = new Set();
    this.root
      .querySelectorAll("[data-filter-checkbox]:checked")
      .forEach(function (checkbox) {
        nextSelectedHandles.add(checkbox.value);
      });
    this.selectedHandles = nextSelectedHandles;

    // No need for cartesian product; backend handles OR logic
    this.syncClearAllState();
    this.renderViaAjax([Array.from(this.selectedHandles)], selectedByGroup);
  };

  window.CustomTagFilters = CustomTagFilters;
})();
